module.exports = __webpack_public_path__ + "img/golissano.a55ffbfc.png";